module.exports = "<a ng-click=exportPosts() translate=app.export_to_csv>Export to CSV</a> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/share/post-export.html
// module id = 782
// module chunks = 0